import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';

import mdToHtml from 'utils/mdToHtml';
import styles from './MdRenderer.module.scss';
import useUnmountedRef from 'hooks/useUnmountedRef';

function MdRenderer({
  className,
  mdString,
  options,
  parseEmojis,
  parseLinks,
  parseMathExpressions,
}) {
  const [parsedString, setParsedString] = useState(null);

  const unMountedRef = useUnmountedRef();

  const loadParsedString = useCallback(async () => {
    setParsedString(null);
    const res = await mdToHtml({
      mdString,
      options,
      parseEmojis,
      parseLinks,
      parseMathExpressions,
    });

    // The below check make's sure to
    // execute the callback only when the component is mounted
    if (unMountedRef.current) {
      return;
    }

    setParsedString({ __html: res });
  }, [
    mdString,
    options,
    parseEmojis,
    parseLinks,
    parseMathExpressions,
    unMountedRef,
  ]);

  useEffect(() => {
    loadParsedString();
  }, [loadParsedString]);

  return (
    <div
      className={classNames(styles.root, {
        [className]: className,
      })}
      dangerouslySetInnerHTML={parsedString}
    />
  );
}

MdRenderer.defaultProps = {
  options: {},
  parseEmojis: true,
  parseLinks: true,
  parseMathExpressions: false,
};

export default MdRenderer;
